import React from "react";
import {Box, Flex, VStack} from "@chakra-ui/react";

const Footer = () => {
  return (
    <Box backgroundColor="gray.800">
      <footer>
        <Flex
          margin="0 auto"
          px={{ base: 6, md: 12 }}
          py={{ base: 6, md: 10 }}
          color="white"
          justifyContent="center"
          alignItems="center"
          maxWidth="1024px"
          height="auto"
          textAlign="center"
        >
          <VStack spacing={{ base: 4, md: 8 }} alignItems="center" fontSize={{ base: 12, md: 13 }}>
          <p>&copy; 2026 Swiftchange Inc. All rights reserved.</p>
          <p> Swiftchange Inc is registered and regularised in Canada by the Financial Transactions 
            and Report Analysis Centre of Canada as a Money Service Business.</p>
          </VStack>
        </Flex>
      </footer>
    </Box>
  );
};
export default Footer;
